<template>
  <div class="entity-details-layout entity-details-layout-list">
    <icon-in-circle class="entity-details-icon">
      <font-awesome-icon icon="box-open"/>
    </icon-in-circle>
    <div class="entity-details-header pv4 ph3 ph1-l">
      <span class="fw6 lh-copy">
        {{ proc.title }}
      </span>
      <div class="mt2 flex">
        <font-awesome-icon :icon="['fa', 'user']" class="w2 mr2 entity-icon"/>
        <span class="silver">{{ manager }}</span>
      </div>
      <div v-if="minBidCountNotReached() || expiredAgreement() || expiredRating()" class="mt3">
        <table class="silver f7">
          <tr v-if="minBidCountNotReached()">
            <td class="silver"><font-awesome-icon icon="exclamation-circle" /></td>
            <td class="pl1">меньше {{ proc.min_bid_count }} участников</td>
          </tr>
          <tr v-if="expiredAgreement()">
            <td class="red"><font-awesome-icon icon="exclamation-circle" /></td>
            <td class="pl1">Cогласование длится более 14 дней</td>
          </tr>
          <tr v-if="expiredRating()">
            <td class="gold" style="vertical-align: top;"><font-awesome-icon icon="exclamation-circle" /></td>
            <td class="pl1">Не выставлен рейтинг более 14 дней с даты поставки</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="entity-details-content ml4-l bt b--near-white bw1">
      <div class="procedure-details-measures ml3 ml0-l mv3">
        <div v-if="daysDuration()" class="flex flex-column">
          <div>
            <font-awesome-icon :icon="['fa', 'clock']" class="f5 mr2 entity-icon"/>
            <span class="">{{ daysDuration() }}</span>
          </div>
          <div class="f6">
            <span class="ttl">Длительность</span>
          </div>
        </div>

        <div v-if="proc.viewed_count" class="flex flex-column">
          <div>
            <font-awesome-icon icon="eye" class="f5 mr2 entity-icon"/>
            <span class="">{{ proc.viewed_count }}</span>
          </div>
          <div class="f6">
            <span class="ttl">Просмотров</span>
          </div>
        </div>

        <div v-if="proc.participants_count" class="flex flex-column">
          <div>
            <font-awesome-icon icon="users" class="f5 mr2 entity-icon"/>
            <span class="">{{ proc.participants_count }}</span>
          </div>
          <div class="f6">
            <span class="ttl" >Участников</span>
          </div>
        </div>

        <div v-if="proc.product_count" class="flex flex-column">
          <div>
            <font-awesome-icon icon="box-open" class="f5 mr2 entity-icon"/>
            <span class="">{{ proc.product_count }}</span>
          </div>
          <div class="f6">
            <span class="ttl">Товаров</span>
          </div>
        </div>
      </div>

      <div class="procedure-details-wrapping-subcontent ml3 ml0-l pt4 bt b--near-white bw1">

        <div v-if="proc.date_open">
          <ul class="timeline">
            <li v-if="proc.date_created" class="">{{ format(proc.date_created) }}<br><span class="timeline-secondary">Формирование</span></li>
            <li v-if="proc.date_open" class="">{{ format(proc.date_open) }}<br><span class="timeline-secondary">Открыт</span></li>
            <li v-if="proc.date_agreement" class="">{{ format(proc.date_agreement) }}<br><span class="timeline-secondary">Cогласование</span></li>
            <li v-if="proc.date_closed" class="">{{ format(proc.date_closed) }}<br><span class="timeline-secondary">Закрыт</span></li>
          </ul>
        </div>

        <div>
          <span class="ttu f6 entity-secondary">Приглашено</span>
          <table class="mt2" cellspacing="0">
            <tr v-if="proc.participants_count">
              <td class="pr2 pv1">ТендерПро</td>
              <td class="tl">{{ proc.participants_count }}</td>
            </tr>
            <tr v-if="proc.product_count">
              <td class="pr2 pv1">Организатором</td>
              <td class="tl">{{ proc.product_count }}</td>
            </tr>
          </table>
        </div>

        <div v-if="proc.price_max">
          <span class="ttu f6 entity-secondary">Цена</span>
          <table class="mt2" cellspacing="0">
            <tr>
              <td class="pr2 pv1">Максимальная</td>
              <td class="tr">{{ proc.price_max }}</td>
            </tr>
            <tr>
              <td class="pr2 pv1">Минимальная</td>
              <td class="tr">{{ proc.price_min }}</td>
            </tr>
            <tr>
              <td class="pr2 pv1">Средняя</td>
              <td class="tr">{{ proc.price_avg }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="procedure-details-list-subcontent ml3 ml0-l pt4 debug">
        <div v-if="proc.winner">
          <span class="ttu f6 entity-secondary">Победитель</span>
          <table class="mt2" cellspacing="0">
            <tr>
              <td class="pr2 pv1 tr" style="vertical-align: text-top;">ФИО</td>
              <td class="tl">{{ part(proc.winner.participant).name }}</td>
            </tr>
            <tr>
              <td class="pr2 pv1 tr" style="vertical-align: text-top;">Причина</td>
              <td>{{ proc.winner.reason }} </td>
            </tr>
            <tr>
              <td class="pr2 pv1 tr" style="vertical-align: text-top;">Цена</td>
              <td class="tl">{{ proc.winner.price }}</td>
            </tr>
          </table>
        </div>

        <div v-if="proc.canceled" class="flex flex-column">
          <span class="ttu f6 entity-secondary">ОТКЛОНЕН</span>
          <span class="mt2">{{ proc.canceled.reason }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import IconInCircle from '@/components/ui/IconInCircle.vue'
import { mapGetters } from 'vuex'
import { humanizeDaysDuration, daysDuration } from '@/plugins/consts.js'
import { momentFromString } from '@/utils/datetime.js'

const moment = require('moment')
moment.locale('ru')

export default {
  components: {
    IconInCircle
  },
  props: ['proc'],
  computed: {
    ...mapGetters('procedure', [
      'organizations', 'managers', 'bid_directions', 'periods', 'statuses', 'procedures', 'participant'
    ]),
    manager () {
      return this.managersMap()[this.proc.manager]?.name || ''
    }
  },
  methods: {
    part (participantId) {
      return this.participant(participantId)
    },
    format (dt) {
      return momentFromString(dt)?.format('LL')
    },
    daysDuration () {
      const proc = this.proc
      if (proc && proc.date_closed) {
        return humanizeDaysDuration(moment(proc.date_open), moment(proc.date_closed))
      } else if (proc.date_open) {
        return humanizeDaysDuration(moment(proc.date_open), moment())
      } else {
        return 0
      }
    },
    managersMap () {
      return Object.fromEntries(this.managers?.map(man => ([man.id, man]) || []))
    },
    expiredAgreement () { // TODO: вынести такой же метод из ListItem в общее место
      const proc = this.proc
      if (proc && proc.status === 2) {
        return daysDuration(moment(proc.date_agreement), moment()) > 14
      } else {
        return null
      }
    },
    expiredRating () { // TODO: вынести такой же метод из ListItem в общее место
      const proc = this.proc
      if (proc && proc.status === 3 && proc.date_delivery && proc.rating === null) {
        return daysDuration(moment(proc.date_delivery), moment()) > 14
      } else {
        return false
      }
    },
    minBidCountNotReached () {
      const proc = this.proc
      if (proc) {
        return proc.status === 1 && proc.bin_count < proc.min_bid_count
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.procedure-details-measures {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  grid-template-rows: auto;
  justify-items: stretch;
  grid-column-gap: 0rem;
  grid-row-gap: 1.4rem;
}
@media screen and (min-width: 60em) {
  .procedure-details-measures {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    grid-template-rows: auto;
    justify-items: stretch;
  }
}

.procedure-details-wrapping-subcontent {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-rows: auto;
  justify-items: stretch;
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
}

.procedure-details-list-subcontent {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  justify-items: stretch;
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
}

.timeline {
  position: relative;
  margin: 0;
  padding: 0;
}
.timeline li {
  list-style: none;
  width: 100%;
  height: 50px;
  position: relative;
  text-align: left;
  color: inherit;
  padding-left: 25px;
}
.timeline + ul:nth-child(1){
  color: #486581;
}
.timeline li:before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  left: 0px;
  top: 3px;
  justify-items: center;
  border: 2px solid #BCCCDC;
  border-radius: 50%;
  display: block;
  margin: 0 auto 0 auto;
}
.timeline li:after {
  content: "";
  position: absolute;
  width: 2px;
  height: 36px;
  background-color: #BCCCDC;
  top: -32px;
  left: 7px;
}
.timeline li:first-child:after {
  content: none;
}
.timeline li.active {
  color: #486581;
}
.timeline li.active:before {
  background: #BCCCDC;
  color: #486581;
}
.timeline li.active + li:after {
  background: #BCCCDC;
}
.timeline-secondary {
  color: #99abb8;
}
</style>
